"use strict";
const _ = require('lodash');
const LENGTHT_OF_GUID = 36;
module.exports = entity => {
    const articleFilterSupplier = _.get(entity, 'articleFilter.supplier', '');
    if (articleFilterSupplier.length === LENGTHT_OF_GUID) {
        _.set(entity, 'articleFilter.supplierId', articleFilterSupplier);
        _.unset(entity, 'articleFilter.supplier');
    }
    return entity;
};
